import { DestroyRef, inject } from '@angular/core';

export interface BaseInterface {
    destroyCallback: () => void;
    destroyRef: DestroyRef;
}

export abstract class AbstractComponent implements BaseInterface {
    public readonly destroyRef = inject(DestroyRef);

    protected constructor() {
        this.destroyRef.onDestroy(() => this.destroyCallback());
    }

    public destroyCallback(): void {}
}
